import { useTranslation } from 'react-i18next';

import { ControlledSelect } from '@components';
import { debtCauseOptions } from '@utils';

export const DebtCause = () => {
  const { t } = useTranslation('subModules/debtCause');

  const options = debtCauseOptions.map((option) => ({
    label: t(option.label),
    value: option.value,
  }));

  return (
    <ControlledSelect
      fieldName="debtCause"
      label={t('label')}
      placeholder={t('placeholder')}
      options={options}
      data-tf-sensitive="true"
      required
    />
  );
};
